// Contact Information Configuration
// Update this file to change contact details across the entire website

export const contactInfo = {
  // Company Details
  companyName: "MNN Construction Group",
  tagline: "Professional construction services with over 10 years of experience. Building your dreams into reality.",
  
  // Contact Information
  phone: "(403) 667-7633",
  email: "Office@mnnconstructiongroup.com",
  

  // Address
  address: {
    street: "23 Cartier Dr",
    city: "St Catharines",
    province: "ON",
    postalCode: "L2M 2E5",
    full: "23 Cartier Dr, St Catharines, ON L2M 2E5"
  },
  
  // Business Hours
  businessHours: {
    weekdays: "Monday - Friday: 8:00 AM - 5:00 PM",
    saturday: "Saturday: 9:00 AM - 5:00 PM",
    sunday: "Sunday: Closed"
  },
  
  // Service Area
  serviceArea: "Niagara Region & Greater Toronto Area (GTA)",
  
  // Social Media (add when available)
  social: {
    facebook: "",
    instagram: "",
    linkedin: "",
    twitter: ""
  },
  
  // SMTP Configuration
  smtp: {
    recipientEmail: "mbileya@gmail.com",
    fromEmail: "easayohard@gmail.com",
    secureToken: "84C589CB908B48CE5CBEA3EC5067AA566A0A83CE9BDBB8957C3EDFC7C8C587761885FCD968189F200F3B24D9CD9D8DAB", // Replace with actual ElasticEmail secure token
    password: "56C8579AB28FA36AD1784B988995E5EDBD24" // Replace with actual ElasticEmail secure token

  },
  
  // Services offered (for contact form dropdown)
  services: [
    { value: "concrete-flatwork", label: "Concrete Flatwork" },
    { value: "curb-gutter", label: "Curb & Gutter Installation" },
    { value: "road-grading", label: "Road Grading & Earthwork" },
    { value: "sewer-upgrades", label: "Sewer Upgrades" },
    { value: "landscaping", label: "Landscaping" },
    { value: "consultation", label: "Free Consultation" },
    { value: "other", label: "Other" }
  ]
};

export default contactInfo;